import React from 'react';
import classNames from 'classnames';
import Columns from 'react-bulma-components/lib/components/columns';

export const Column = ({ children, className, ...props }) => (
  <Columns.Column className={classNames(className)} {...props}>
    {children}
  </Columns.Column>
);

export default Column;
